<template>
   <div>
     <div class="load">
       <img :src="src" alt="loading...">
     </div>
   </div>
</template>

<script>
export default {
   name: 'load',
   props: {
     src: String
   },
   data() {
       return {}
   },
  components: {}
}
</script>

<style scoped lang="scss">
.load {
  width: 100%;
  height: 100vh;
  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FightGroups/components/Load.vue